"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _grid = require("@jsluna/grid");

var _link = require("@jsluna/link");

var _form = require("@jsluna/form");

var _typography = require("@jsluna/typography");

var _labs = require("@jsluna/labs");

var _icons = require("@jsluna/icons");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable prettier/prettier */


var AddressForm = function AddressForm(props) {
  var _address$businessName, _address$buildingName, _address$buildingName2, _address$buildingName3, _address$buildingNumb, _address$buildingNumb2, _address$buildingNumb3, _address$flatNumber, _address$addressLine, _address$addressLine2, _address$addressLine3, _address$city, _address$city2, _address$city3, _address$postcode, _address$postcode2;

  var address = props.address,
      setAddress = props.setAddress,
      setManualAddressEntry = props.setManualAddressEntry,
      manualAddressEntry = props.manualAddressEntry,
      hasErrors = props.hasErrors,
      showValidationErrors = props.showValidationErrors,
      clearValidationErrors = props.clearValidationErrors;

  var _useState = (0, _react.useState)([]),
      readOnlyMissingData = _useState[0],
      setReadOnlyMissingData = _useState[1];

  var updateAddress = function updateAddress(property, event) {
    var _Object$assign;

    if (!readOnlyMissingData.includes(property)) {
      setReadOnlyMissingData([].concat(readOnlyMissingData, [property]));
    }

    setAddress(Object.assign({}, address, (_Object$assign = {}, _Object$assign[property] = event.target.value, _Object$assign)));
  };

  var postcodeRegEx = /(?:[A-Za-z]\d ?\d[A-Za-z]{2})|(?:[A-Za-z][A-Za-z\d]\d ?\d[A-Za-z]{2})|(?:[A-Za-z]{2}\d{2} ?\d[A-Za-z]{2})|(?:[A-Za-z]\d[A-Za-z] ?\d[A-Za-z]{2})|(?:[A-Za-z]{2}\d[A-Za-z] ?\d[A-Za-z]{2})/;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_grid.GridWrapper, {
    className: "ln-u-flush-left"
  }, /*#__PURE__*/_react.default.createElement(_grid.GridItem, {
    className: "ln-u-hard-left",
    size: {
      xs: '6/10',
      ss: '1/2',
      sm: '2/5',
      lg: '1/4',
      xl: '1/3'
    }
  }, manualAddressEntry || readOnlyMissingData.includes('businessName') || (address == null ? void 0 : (_address$businessName = address.businessName) == null ? void 0 : _address$businessName.length) === 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-business-name",
    optionalLabel: "(optional)"
  }, "Business name"), /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    name: "address-business-name-input-field",
    maxLength: 100,
    onChange: function onChange(e) {
      return updateAddress('businessName', e);
    }
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-business-name"
  }, "Business name"), /*#__PURE__*/_react.default.createElement(_typography.Body1, {
    className: "ln-u-margin-top ln-u-margin-bottom*2",
    element: "p"
  }, address == null ? void 0 : address.businessName)), manualAddressEntry || readOnlyMissingData.includes('buildingName') || (address == null ? void 0 : (_address$buildingName = address.buildingName) == null ? void 0 : _address$buildingName.length) === 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasErrors && showValidationErrors && (address === null || ((address == null ? void 0 : (_address$buildingName2 = address.buildingName) == null ? void 0 : _address$buildingName2.length) === 0 || (address == null ? void 0 : (_address$buildingName3 = address.buildingName) == null ? void 0 : _address$buildingName3.length) === undefined) && ((address == null ? void 0 : (_address$buildingNumb = address.buildingNumber) == null ? void 0 : _address$buildingNumb.length) === 0 || (address == null ? void 0 : (_address$buildingNumb2 = address.buildingNumber) == null ? void 0 : _address$buildingNumb2.length) === undefined)) && /*#__PURE__*/_react.default.createElement(_labs.Alert, {
    className: "ln-u-margin-bottom*2",
    error: true
  }, /*#__PURE__*/_react.default.createElement(_labs.AlertIcon, null, /*#__PURE__*/_react.default.createElement(_icons.ErrorCircle, null)), "Please enter a house or building name, or a house or building number"), /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-building-name",
    optionalLabel: !manualAddressEntry && "(optional)"
  }, "House or building name"), /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    name: "address-name-input-field",
    maxLength: 500,
    onChange: function onChange(e) {
      return updateAddress('buildingName', e);
    }
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-building-name"
  }, "House or building name"), /*#__PURE__*/_react.default.createElement(_typography.Body1, {
    className: "ln-u-margin-top ln-u-margin-bottom*2",
    element: "p"
  }, address == null ? void 0 : address.buildingName)), manualAddressEntry || readOnlyMissingData.includes('buildingNumber') || (address == null ? void 0 : (_address$buildingNumb3 = address.buildingNumber) == null ? void 0 : _address$buildingNumb3.length) === 0 ? /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    name: "address-number-input-field",
    label: "Or house or building number",
    maxLength: 100,
    onChange: function onChange(e) {
      return updateAddress('buildingNumber', e);
    }
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-building-number"
  }, "Or house or building number"), /*#__PURE__*/_react.default.createElement(_typography.Body1, {
    className: "ln-u-margin-top ln-u-margin-bottom*2",
    element: "p"
  }, address == null ? void 0 : address.buildingNumber)), manualAddressEntry || readOnlyMissingData.includes('flatNumber') || (address == null ? void 0 : (_address$flatNumber = address.flatNumber) == null ? void 0 : _address$flatNumber.length) === 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-flat-number",
    optionalLabel: "(if relevant)"
  }, "Flat number"), /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    name: "address-flat-number-input-field",
    maxLength: 100,
    onChange: function onChange(e) {
      return updateAddress('flatNumber', e);
    }
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-flat-number"
  }, "Flat number"), /*#__PURE__*/_react.default.createElement(_typography.Body1, {
    className: "ln-u-margin-top ln-u-margin-bottom*2",
    element: "p"
  }, address == null ? void 0 : address.flatNumber)), manualAddressEntry || readOnlyMissingData.includes('addressLine1') || (address == null ? void 0 : (_address$addressLine = address.addressLine1) == null ? void 0 : _address$addressLine.length) === 0 ? /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    name: "address-line1-input-field",
    label: "Address line 1",
    maxLength: 500,
    error: hasErrors && showValidationErrors && (address === null || (address == null ? void 0 : (_address$addressLine2 = address.addressLine1) == null ? void 0 : _address$addressLine2.length) === 0 || (address == null ? void 0 : (_address$addressLine3 = address.addressLine1) == null ? void 0 : _address$addressLine3.length) === undefined) && 'Please enter address line 1',
    onChange: function onChange(e) {
      return updateAddress('addressLine1', e);
    }
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-address-line-1"
  }, "Address line 1"), /*#__PURE__*/_react.default.createElement(_typography.Body1, {
    className: "ln-u-margin-top ln-u-margin-bottom*2",
    element: "p"
  }, address == null ? void 0 : address.addressLine1)), manualAddressEntry || readOnlyMissingData.includes('city' || (address == null ? void 0 : (_address$city = address.city) == null ? void 0 : _address$city.length) === 0) ? /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    name: "address-city-input-field",
    label: "Town or city",
    maxLength: 500,
    error: hasErrors && showValidationErrors && (address === null || (address == null ? void 0 : (_address$city2 = address.city) == null ? void 0 : _address$city2.length) === 0 || (address == null ? void 0 : (_address$city3 = address.city) == null ? void 0 : _address$city3.length) === undefined) && 'Please enter a town or city',
    onChange: function onChange(e) {
      return updateAddress('city', e);
    }
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-city"
  }, "Town or city"), /*#__PURE__*/_react.default.createElement(_typography.Body1, {
    className: "ln-u-margin-top ln-u-margin-bottom*2",
    element: "p"
  }, address == null ? void 0 : address.city)), manualAddressEntry || readOnlyMissingData.includes('postcode') || (address == null ? void 0 : (_address$postcode = address.postcode) == null ? void 0 : _address$postcode.length) === 0 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-postcode",
    optionalLabel: "(if obtained)"
  }, "Postcode"), /*#__PURE__*/_react.default.createElement(_form.TextInputField, {
    name: "address-postcode-input-field",
    maxLength: 8,
    error: showValidationErrors && !postcodeRegEx.test(address == null ? void 0 : address.postcode) && (address == null ? void 0 : (_address$postcode2 = address.postcode) == null ? void 0 : _address$postcode2.length) > 0 && 'Please enter a valid postcode',
    onChange: function onChange(e) {
      return updateAddress('postcode', e);
    }
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.Label, {
    htmlFor: "label-postcode"
  }, "Postcode"), /*#__PURE__*/_react.default.createElement(_typography.Body1, {
    className: "ln-u-margin-top ln-u-margin-bottom*2",
    element: "p"
  }, address == null ? void 0 : address.postcode)), /*#__PURE__*/_react.default.createElement(_link.Link, {
    onClick: function onClick() {
      setAddress(null);
      setManualAddressEntry(false);
      clearValidationErrors(false);
    }
  }, "Remove this address"))));
};

AddressForm.propTypes = {
  address: _propTypes.PropTypes.object,
  setAddress: _propTypes.PropTypes.func.isRequired,
  setManualAddressEntry: _propTypes.PropTypes.func.isRequired,
  manualAddressEntry: _propTypes.PropTypes.bool,
  hasErrors: _propTypes.PropTypes.bool,
  showValidationErrors: _propTypes.PropTypes.bool,
  clearValidationErrors: _propTypes.PropTypes.func.isRequired
};
AddressForm.defaultProps = {
  address: null,
  manualAddressEntry: true,
  hasErrors: false,
  showValidationErrors: false
};
var _default = AddressForm;
exports.default = _default;